// Timeline card dispatcher.
// Routes each TimeMark to the appropriate card renderer based on its cardType.
//
// To add a new card type:
//   1. Create a new component in this directory (e.g. TimelineImageCard.tsx)
//   2. Import shared styles from TimelineCardStyles.ts for the outer shell
//   3. Add a case to the switch below

import type {TimeMark} from "../../../../sdo/TimeMark.ts";
import TimelineTextCard from "./TimelineTextCard.tsx";

export default function TimelineCard({mark, icon}: { mark: TimeMark; icon: string }) {
    switch (mark.cardType) {
        // case "image":
        //     return <TimelineImageCard mark={mark} icon={icon} />;
        // case "url":
        //     return <TimelineUrlCard mark={mark} icon={icon} />;
        case "text":
        default:
            return <TimelineTextCard mark={mark} icon={icon} />;
    }
}
